<template>
  <Avatar :customer="profile" class="gmf-avatar" disableOnlineIndicator />
</template>

<style>
.gmf-my-avatar-thumbnail {
  pointer-events: none;
  line-height: 0;
  height: 100%;
  width: 100%;
}
.gmf-my-avatar-thumbnail img {
  width: 100%;
  height: auto;
  display: block;
}
</style>

<script>
import state from '@/state';
import Avatar from '@/components/Avatar';

export default {
  components: {
    Avatar,
  },
  name: 'MyAvatarThumbnail',
  data () {
    return {
      state,
    };
  },
  computed: {
    profile() {
      return this.state.profile;
    }
  },
};
</script>
